import React from "react";

import { css } from "@emotion/css";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { SupportInfo } from "@/models/SupportInfoModel.ts";

export type ContactSupportProps = TypographyProps & {
  support: SupportInfo;
};

export const ContactSupport: React.FC<ContactSupportProps> = ({ support, ...props }) => {
  const { t } = useTranslation();
  return (
    <Typography component="span" {...props}>
      {t("support.contactUs")}
      <ContactSupportInfo support={support} />
    </Typography>
  );
};

export const ContactSupportInfo: React.FC<ContactSupportProps> = ({ className, support }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Typography component="span" className={className}>
      {`${t("support.byEmail")} `}
      <Typography component="a" href={`mailto:${support.supportEmail}`} className={styles.link}>
        {support.supportEmail}
      </Typography>
      {` ${t("support.or")} ${t("support.byPhone")} `}
      <Typography component="a" href={`tel:${support.supportPhoneNumber}`} className={styles.link}>
        {support.supportPhoneNumber}
      </Typography>
    </Typography>
  );
};

const makeStyles = () => ({
  link: css({
    color: "inherit",
    cursor: "pointer",
  }),
});
